import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LoyaltyAcmLayoutService } from 'app/services/loyalty/loyalty-acm-layout.service';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'loyalty-layout3-form',
  templateUrl: 'layoutForm-3.html'
})

export class LoyaltyLayout3FormComponent implements OnInit {
  @Output() layoutAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() layoutUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() layoutObj: any;
  @Input() layoutList: any;
  addEditForm: FormGroup;
  mode: string;
  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private srvLayout: LoyaltyAcmLayoutService) {}

  ngOnInit(): void {

    this.srvLayout.getFields().subscribe(res => {
      this.fields = res;
    });

    if (this.layoutObj) {
      this.mode = 'edit';
    } else {
      this.mode = 'add';
    }
      this.addEditForm = this.fb.group({
        'layout_id': new FormControl(this.layoutObj ? this.layoutObj.layout_id : null),
        'description_fe': new FormControl(this.layoutObj ? this.layoutObj.description_fe : null),
        'format_string': new FormControl(this.layoutObj ? this.layoutObj.format_string : null),
    });
  }

  saveOrUpdate(): void {

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    const newData = Object.assign({}, this.layoutObj, this.addEditForm.value);

    if (this.mode === 'add') {
      this.layoutAdded.emit(newData);
    } else if (this.mode === 'edit') {
      this.layoutUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty-3/form-acm-loyalty-3/layoutForm-3.component.ts